var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"crm-status justify-center",class:[String(_vm.status.color), String(_vm.color), {'crm-status_large': _vm.large}],attrs:{"small":"","dark":"","close":_vm.close},on:{"click:close":_vm.remove}},[_vm._v(" "+_vm._s(_vm.status.text || _vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }